import {Observable, Subject} from 'rxjs';

export class ModalRef<T = any> {

  private closed$ = new Subject<T | undefined>();

  afterClosed(): Observable<T | undefined> {
    return this.closed$.asObservable();
  }

  close(result?: T): void {
    this.closed$.next(result);
    this.closed$.complete();
  }
}
